import { Table, Typography } from 'antd'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import { ColumnsType } from 'antd/es/table'
import { CloseCircle, Copy, DocumentText1 } from 'iconsax-react'
import { AdminsLoyaltyGetVoucherListResponseItem } from 'generated/api'
import { copyTextToClipboard } from 'helpers/copyToClipboard'
import Button from 'components/button/Button'
import { VoucherStatusEnum } from '../hooks/useVoucher'

interface Props {
  data: AdminsLoyaltyGetVoucherListResponseItem[]
  onClickCancelModal: (voucher: AdminsLoyaltyGetVoucherListResponseItem) => void
}

export default function VoucherTable(props: Props) {
  const navigate = useNavigate()

  const titleColumn = (title: string, dataTestId: string) => (
    <div data-testid={dataTestId}>
      <Typography.Text className="text-base font-bold text-[#323539]">{title}</Typography.Text>
    </div>
  )

  const columnsOrder: ColumnsType<AdminsLoyaltyGetVoucherListResponseItem> = [
    {
      title: titleColumn('Informasi Voucher', 'btn_sort_information_voucher'),
      width: '27%',
      dataIndex: 'name',
      key: 'name',
      render: (name, row) => (
        <div data-testid="link_column_name" className="flex flex-col gap-2">
          <Typography.Text className="text-lg font-bold	text-[#323539]">{name}</Typography.Text>
          <Typography.Text className="text-base font-medium text-[#323539]">
            {row.label}
          </Typography.Text>
          {row.code && (
            <Typography.Text className="text-sm font-medium text-[#323539] p-2 bg-[#F4F6F0] rounded-lg w-fit">
              Voucher Khusus{' '}
              <Typography.Text className="text-sm font-bold text-[#323539]">
                {row.code}{' '}
                <Copy
                  size="16"
                  className="hover:cursor-pointer"
                  onClick={() => copyTextToClipboard(row.code as string)}
                />
              </Typography.Text>
            </Typography.Text>
          )}
        </div>
      ),
    },
    {
      title: titleColumn('Kuota & Penggunaan', 'btn_sort_number_voucher'),
      width: '30%',
      dataIndex: 'totalRedemption',
      key: 'totalRedemption',
      render: (totalRedemption, row) => (
        <div data-testid="link_column_number_voucher" className="flex flex-col gap-1">
          <Typography.Text className="text-base font-normal">
            Voucher Digunakan: {totalRedemption}
            <Typography.Text className="text-base font-bold">
              {` / ${row.maxRedemption}`}
            </Typography.Text>
          </Typography.Text>
          <Typography.Text className="text-base font-normal">
            Jumlah Pengguna:
            <Typography.Text className="text-base font-bold">
              {` ${row.maxRedemptionPerUser}`}
            </Typography.Text>
          </Typography.Text>
        </div>
      ),
    },
    {
      title: titleColumn('Periode & Status', 'btn_sort_period_status'),
      width: '30%',
      dataIndex: 'status',
      key: 'status',
      render: (status, row) => (
        <div data-testid="link_column_period_status" className="flex flex-col gap-4">
          <Typography.Text className="text-base font-bold">
            {`${dayjs(row.startDatetimeAtUtc0).format('DD MMM YYYY')} - ${dayjs(
              row.endDatetimeAtUtc0,
            ).format('DD MMM YYYY')}`}
          </Typography.Text>
          <div className="text-xs font-normal text-[#3C5337] bg-[#F4F6F0] rounded-lg border-[#91A669] border border-solid text-center w-2/6 py-1.5 px-2">
            {status === 'ACTIVE' ? 'Aktif' : 'Tidak Aktif'}
          </div>
        </div>
      ),
    },
    {
      title: titleColumn('Aksi', 'btn_sort_action'),
      width: '13%',
      dataIndex: 'id',
      key: 'id',
      render: (id, voucher) => (
        <div data-testid="link_column_action" className="flex flex-col gap-2">
          <Button
            icon={<DocumentText1 size={16} color="#858C95" />}
            className="text-[#858C95] bg-white border-none p-0 w-fit"
            onClick={() => navigate(`/loyalty/vouchers/detail/${id}`)}
          >
            Lihat Detail
          </Button>
          {voucher.status === VoucherStatusEnum.ACTIVE && (
            <Button
              icon={<CloseCircle size={16} color="#FF4D4D" />}
              className="text-[#FF4D4D] bg-white border-none p-0 w-fit"
              onClick={() => props.onClickCancelModal(voucher)}
            >
              Hentikan
            </Button>
          )}
        </div>
      ),
    },
  ]

  return (
    <Table
      rowKey="id"
      data-testid="table_voucher"
      className="table-voucher"
      columns={columnsOrder}
      dataSource={props.data}
      pagination={false}
    />
  )
}
